import { render, staticRenderFns } from "./HeaderPeople.vue?vue&type=template&id=e60d6ec8&scoped=true&"
import script from "./HeaderPeople.vue?vue&type=script&lang=js&"
export * from "./HeaderPeople.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPeople.vue?vue&type=style&index=0&id=e60d6ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60d6ec8",
  null
  
)

export default component.exports